import { createSlice } from '@reduxjs/toolkit'
import axios from 'axios'


export const avanceSlice = createSlice({
    name: 'avance', //importante, ya que se realizara llamdo mas tarde por nombre
    initialState: {
        avance: {}
    },
    reducers: {
        setAvance: (state, action) => {  //crear set
            state.avance = action.payload
        }
    }
})


export const {  setAvance } = avanceSlice.actions

export default avanceSlice.reducer



export const getAvance = (data) => async (dispatch) => {


    try {


        return await axios
            .post(
                'https://ws.ugm.cl/api/v1_ufe/ufe_avance_academico', data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': process.env.REACT_APP_TOKEN
                    }
                }
            )
            .then(response => {
                 //console.log('sdsds', response.data)
                dispatch(setAvance(response.data))

            })

    } catch (error) {

        //console.log('dispatch error', error)

    }


}